export const styles = {
  root: {
    background: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 48,
    zIndex: 1,
    position: 'sticky',
    top: 0,
  },
  highlight: {
    background: '#F8F8F8',
  },
  inputWrapper: {
    margin: '0 50px',
  },
  formControl: {
    minWidth: '120px !important',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/AssignSpyToolbar/styles.js